import { Language } from '../constants/languages';
export const AMOUNT_FALLBACK_TEXT = '-';
export const AMOUNT_TRANSLATION_KEYS = {
  day: 'component.Amount.day',
  month: 'component.Amount.month',
  year: 'component.Amount.year'
};
export const AMOUNT_TRANSLATIONS = {
  [Language.EN]: {
    [AMOUNT_TRANSLATION_KEYS.day]: 'day',
    [AMOUNT_TRANSLATION_KEYS.month]: 'month',
    [AMOUNT_TRANSLATION_KEYS.year]: 'year'
  },
  [Language.PL]: {
    [AMOUNT_TRANSLATION_KEYS.day]: 'dzień',
    [AMOUNT_TRANSLATION_KEYS.month]: 'mies.',
    [AMOUNT_TRANSLATION_KEYS.year]: 'rok'
  },
  [Language.CS]: {
    [AMOUNT_TRANSLATION_KEYS.day]: 'den',
    [AMOUNT_TRANSLATION_KEYS.month]: 'měs.',
    [AMOUNT_TRANSLATION_KEYS.year]: 'rok'
  },
  [Language.SK]: {
    [AMOUNT_TRANSLATION_KEYS.day]: 'deň',
    [AMOUNT_TRANSLATION_KEYS.month]: 'mes.',
    [AMOUNT_TRANSLATION_KEYS.year]: 'rok'
  }
};
const CurrencyDisplayType = {
  CODE: 'code',
  SYMBOL: 'symbol'
};
const StyleType = {
  CURRENCY: 'currency',
  DECIMAL: 'decimal',
  PERCENT: 'percent',
  COUNTDOWN: 'countdown'
};
const DateType = {
  DAY: 'day',
  MONTH: 'month',
  YEAR: 'year'
};
export { CurrencyDisplayType, StyleType, DateType };